import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] p-6">
      <div className="w-full max-w-md">
        <Link to="/" className="font-display font-extrabold text-xl mb-10 inline-block">BeatCredsi<span className="text-amber-500 text-sm align-super">™</span></Link>
        <div className="text-overline mb-4">Recover Access</div>
        <h1 className="font-display text-3xl lg:text-4xl font-medium tracking-tight mb-3">Forgot password.</h1>
        <p className="text-neutral-400 mb-8">Enter your email and we'll send you a reset link.</p>

        {!sent ? (
          <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
            <div>
              <label className="text-xs text-neutral-400 uppercase tracking-widest mb-2 block">Email</label>
              <input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-[#161616] border border-white/20 px-4 py-3 text-white outline-none focus:border-amber-500 focus:ring-1 focus:ring-amber-500/40" />
            </div>
            {error && <div data-testid="forgot-error" className="text-sm text-rose-400 bg-rose-500/10 border border-rose-500/20 px-3 py-2">{error}</div>}
            <button data-testid="forgot-submit-btn" type="submit" disabled={busy}
              className="w-full bg-amber-500 text-black font-semibold py-3 hover:brightness-110 disabled:opacity-50">
              {busy ? "Sending…" : "Send Reset Link"}
            </button>
          </form>
        ) : (
          <div data-testid="forgot-sent-message" className="p-5 border border-emerald-500/30 bg-emerald-500/5">
            <div className="text-overline text-emerald-400 mb-2">Check Your Email</div>
            <p className="text-sm text-neutral-200">
              If an account exists for <span className="text-amber-500">{email}</span>, a password reset link has been sent.
              It will expire in 2 hours.
            </p>
            <p className="text-xs text-neutral-500 mt-3">Didn't get it? Check spam, then try again.</p>
          </div>
        )}

        <div className="mt-8">
          <Link to="/login" className="text-sm text-neutral-400 hover:text-amber-500" data-testid="back-to-login">← Back to login</Link>
        </div>
      </div>
    </div>
  );
}
